import { renderRoutes } from 'react-router-config';
import { getRoutes, RFC } from 'configs/navigation';

const People: RFC = ({ route }) => {
  return renderRoutes(getRoutes(route));
};

export default People;
